<template>
    <v-flex></v-flex>
</template>

<script>
    export default {
        name: "RedirectTan",
        data() {
            return {
                url: '',
                divCode:'',
            }
        },
        created(){
            this.url =  this.$route.params.url;
            this.divCode =  this.$route.params.divCode;

        },
        mounted(){
            if(this.$route.params.divCode){
                window.open("https://"+this.url+"/#/clinicd/"+this.divCode);//webreg.taianhospital.com.tw
                window.history.back();
            }

        }
    }
</script>

<style scoped>

</style>